import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from '../../environment/environment';
import { FeedbackModel, TopicRequestModel } from '../models/feedback.model';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private http: HttpClient) {}

  sendContactMail(feedback: FeedbackModel) {
    const formData = new FormData();
    formData.append('mode', 'sendContactMail');
    formData.append('first_name', feedback.firstName);
    formData.append('last_name', feedback.lastName);
    formData.append('email', feedback.email);
    formData.append('subject', feedback.subject);
    formData.append('message', feedback.message);

    return this.http
      .post<{
        success: boolean;
        message: string;
      }>(environment.authority_short + 'contact.php', formData)
      .pipe(
        map(response => response),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  sendTopicRequestMail(topicRequest: TopicRequestModel) {
    const formData = new FormData();
    formData.append('mode', 'sendTopicRequest');
    formData.append('name', topicRequest.name);
    formData.append('email', topicRequest.email);
    formData.append('topic_request', topicRequest.topic);

    return this.http
      .post<{
        success: boolean;
        message: string;
      }>(environment.authority_short + 'contact.php', formData)
      .pipe(
        map(response => response),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }
}
